module.exports = __webpack_public_path__ + "img/new8.fe2bd7eb.jpg";